import { Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { RoleService } from '../../services/role_service/role.service';

@Component({
    selector: 'app-help-page',
    standalone: true,
    imports: [
        MatSidenavModule,
        MatGridListModule,
        MatCardModule,
        MatIconModule,
        MatExpansionModule,
        MatDividerModule,
        MatButtonModule
    ],
    templateUrl: './help.component.html',
    styleUrl: './help.component.scss'
})
export class HelpPageComponent {
    constructor(public roleService: RoleService) { }

    openMailClient() {
        const email = 'appfeedback@wheel.me';
        const subject = 'Intervention Tracker: [your subject]';
        const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
        window.location.href = mailtoLink;
    }

    scrollToFaqElement(elementId: string) {
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
}
